<template>
  <div>
    <h2>Fill in your contact details</h2>
    <app-fill-in-contact-details></app-fill-in-contact-details>
  </div>
</template>

<script>
import FillInContactDetails from "@/components/BookingApp/UserView/FillInContactDetails";
import { eventBus } from "@/components/BookingApp/eventbus.js";
export default {
  name: "ContactDetails",
  components: {
    appFillInContactDetails: FillInContactDetails,
  },
  created: function () {
    var self = this;
    eventBus.$on("book-now", function () {
      // go to booking completed page
      self.$router.push("/booking-completed");
    });
  },
};
</script>

<style>
</style>